<template>

<div v-cloak class="blacklist">

  <div v-for="number in blacklist" v-bind:key="number.id" :id="number.id" class="push-half--bottom">
    <h3 class="number flush--bottom">
      <div class="button-group flush--bottom push-half--top push-half--right float--right" v-if="allowNew">
        <button class="button button--small button--light" @click="remove(number)">{{ $_('delete') }}</button>
      </div>
      <a class="card flush--bottom"><span>{{ number.formattedNumber }}</span></a>
    </h3>
  </div>
  <p v-show="!blacklist.length">{{ $_('blacklist_no_numbers') }}</p>

  <button type="button" class="button button--primary button--small" v-if="!showNew && allowNew" @click="showNew = !showNew">{{ $_('add') }}</button>
  <form class="push--top" v-if="allowNew && showNew" v-on:submit.prevent="onSubmit('newNumber')" data-vv-scope="newNumber">
    <h3 class="push-half--bottom">{{ $_('blacklist_a_number') }}</h3>
    <div class="form">
      <div class="form__line push-half--bottom">
        <div class="form__field">
          <label for="number">{{ $_('phone_number') }}:</label>
          <the-mask type="tel" v-validate="'required|digits:10'" :mask="mask" name="number" id="number" v-model.number="newNumber.number" class="field field--text" :class="{ 'parsley-error': errors.has('newNumber.number') }" />
          <span v-show="errors.has('newNumber.number')" class="parsley-errors-list ">{{ errors.first('newNumber.number') }}</span>
        </div>
      </div>
    </div>
    <div class="form__line flush--bottom">
      <button type="submit" class="button button--primary button--small" v-if="!loading">{{ $_('submit') }}</button>
      <button type="button" class="button button--default button--small" v-if="!loading" @click="clearNew(); showNew = !showNew">{{ $_('cancel') }}</button>
      <i class="fa fa-spin fa-spinner" v-if="loading"></i>
    </div>
  </form>
  <div class="form__line push--top flush--bottom" v-if="error">
    <div class="form__field">
      <div class="parsley-error">{{ error }}</div>
    </div>
  </div>
</div>

</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
  name: 'blacklist',
  components: {
    TheMask,
  },
  props: ['clientId'],
  data () {
    return {
      mask: '+1 (###) ###-####',
      user: user,
      blacklist: [],
      error: null,
      newNumber: {
        id: null,
        number: '',
      },
      loading: false,
      showNew: false
    }
  },
  computed: {
    isAdmin () {
      return user && user.admin === 1;
    },
    isAccountAdmin () {
      return user && user.admin === 2;
    },
    allowNew () {
      return this.isAdmin || (this.isAccountAdmin && this.clientId)
    }
  },
  mounted () {
    this.getBlacklist();
  },
  methods: {
    getBlacklist: function() {
      var self = this;
      this.$http.get("/api/v1/blacklist").then(
        function(response) {
          self.blacklist = response.data.blacklist.filter(function(number) {
            return (self.clientId) ? number.client_id === self.clientId : number.client_id === null;
          });
        },
        function(error) {
          console.error(error);
        }
      )
    },
    allowDelete: function(number) {
      if (this.isAdmin) {
        return true;
      } else if (this.allowNew) {
        return (number.client_id === this.clientId);
      }
    },
    clearNew: function() {
      this.newNumber = {
        number: '',
      };
      this.$validator.reset();
      this.error = null;
    },
    onSubmit: function(scope) {
      var self = this;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        if (confirm(self.$_('blacklist_create_confirmation'))) {
          var data = {
            number: '+1' + self.newNumber.number,
          };
          self.post(data);
        }
      });
    },
    post: function(data) {
      var self = this;
      if (self.clientId) {
        data.client_id = self.clientId;
      }
      self.loading = true;
      self.$http.post('/api/v1/blacklist', data).then(
        function(response) {
          if (response.data.status) {
            self.getBlacklist();
            self.clearNew();
          }
          self.loading = false;
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
          self.loading = false;
        }
      );
    },
    remove: function(data) {
      if (!confirm(this.$_('blacklist_delete_confirmation'))) { return false; }
      var self = this;
      self.$http.delete('/api/v1/blacklist/' + data.id).then(
        function(response) {
          if (response.data.status) {
            self.getBlacklist();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    },
  }
}

</script>

<style lang="scss">
.blacklist {
  .number {
    display: block;

    .button-group {
      position: relative;
      top: -5px;
    }
  }
  .card {
    display: block;
    color: inherit;
    font-weight: normal;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/Blacklist.vue